import { findDocumentBySlug, type CatalogDocumentWithMeta } from "./documentCatalog";

// Maps an Annex A control id to the document template in the catalog that
// most directly fulfils it. Used by the ControlDetail pages for the primary
// CTA: a mapped control links straight to that template's preview page, an
// unmapped control falls back to the Gap Analysis / Document Pack CTAs.
export const controlDocumentMap: Record<string, string> = {
  // Organizational
  '5.1': 'iso-27001-information-security-policy',
  '5.9': 'iso-27001-asset-management-policy',
  '5.10': 'iso-27001-acceptable-use-policy',
  '5.12': 'iso-27001-data-classification-and-handling-policy',
  '5.13': 'iso-27001-information-classification-policy',
  '5.15': 'iso-27001-access-control-policy',
  '5.16': 'iso-27001-access-control-policy',
  '5.17': 'iso-27001-password-policy',
  '5.18': 'iso-27001-access-control-policy',
  '5.19': 'iso-27001-supplier-relationship-security-policy',
  '5.20': 'iso-27001-supplier-relationship-security-policy',
  '5.21': 'iso-27001-third-party-security-policy',
  '5.22': 'iso-27001-supplier-relationship-security-policy',
  '5.23': 'iso-27001-cloud-security-policy',
  '5.24': 'iso-27001-incident-management-policy',
  '5.25': 'iso-27001-incident-management-policy',
  '5.26': 'iso-27001-incident-management-policy',
  '5.27': 'iso-27001-incident-management-policy',
  '5.29': 'iso-27001-business-continuity-policy',
  '5.30': 'iso-27001-business-continuity-policy',
  '5.31': 'iso-27001-compliance-policy',
  '5.34': 'iso-27001-data-protection-policy',
  '5.35': 'iso-27001-it-security-audit-policy',
  '5.36': 'iso-27001-compliance-policy',
  '5.37': 'iso-27001-document-control-policy',
  // People
  '6.1': 'iso-27001-human-resources-security-policy',
  '6.2': 'iso-27001-human-resources-security-policy',
  '6.3': 'iso-27001-human-resources-security-policy',
  '6.4': 'iso-27001-human-resources-security-policy',
  '6.5': 'iso-27001-human-resources-security-policy',
  '6.6': 'iso-27001-human-resources-security-policy',
  '6.7': 'iso-27001-mobile-device-and-remote-working-policy',
  // Physical
  '7.1': 'iso-27001-physical-security-policy',
  '7.2': 'iso-27001-physical-security-policy',
  '7.3': 'iso-27001-physical-security-policy',
  '7.4': 'iso-27001-physical-security-policy',
  '7.5': 'iso-27001-physical-and-environmental-security-policy',
  '7.7': 'iso-27001-clear-desk-and-clear-screen-policy',
  // Technological
  '8.1': 'iso-27001-endpoint-security-policy',
  '8.8': 'iso-27001-vulnerability-management-policy',
  '8.13': 'iso-27001-backup-policy',
  '8.15': 'iso-27001-logging-and-monitoring-policy',
  '8.16': 'iso-27001-logging-and-monitoring-policy',
  '8.20': 'iso-27001-network-security-policy',
  '8.21': 'iso-27001-network-security-policy',
  '8.22': 'iso-27001-network-security-policy',
  '8.24': 'iso-27001-cryptography-and-key-management-policy',
  '8.25': 'iso-27001-secure-development-policy',
  '8.26': 'iso-27001-secure-development-policy',
  '8.27': 'iso-27001-secure-development-policy',
  '8.28': 'iso-27001-secure-development-policy',
  '8.29': 'iso-27001-secure-development-policy',
  '8.30': 'iso-27001-secure-development-policy',
  '8.32': 'iso-27001-change-management-policy',
};

export function getMappedDocumentForControl(controlId: string): CatalogDocumentWithMeta | null {
  const slug = controlDocumentMap[controlId];
  if (!slug) return null;
  return findDocumentBySlug(slug);
}